import { useContext } from "react";
import { getcustomerfromname, getemployeefromempid } from "../../utilities/Convertions";





export const formatToNewDataStructure = async (quotestuff,customers,employees,papers)=>{

const customerMatch = await  getcustomerfromname(quotestuff.customer,customers);
const salesrepMatch = getemployeefromempid(quotestuff.salesrep,employees);

const displayCustomer = customerMatch || {name:quotestuff.customer};

const displaySalesrep = salesrepMatch || {
empId:quotestuff.salesrep,
firstName:"Legacy",
lastName:quotestuff.salesrep
};





let resolvedContact = null;

if (customerMatch?.contacts?.length) {

  // 1️⃣ Try legacy contact match
  if (quotestuff.contact) {
    resolvedContact = customerMatch.contacts.find(
      c => String(c.old) === String(quotestuff.contact)
    );
  }

  // 2️⃣ If not found, use customer's main contact
  if (!resolvedContact && customerMatch?.maincontact) {
    resolvedContact = customerMatch.contacts.find(
      c => String(c.contactid) === String(customerMatch.maincontact)
    );
  }

}


const Data = {
  entered: quotestuff.entered ? new Date(quotestuff.entered) : null,
  customer: displayCustomer,
  contacts: customerMatch?.contacts || [],
  contact: resolvedContact || null,

  salesrep: displaySalesrep,

  customerid: quotestuff.customerid || "",

  prevjob: quotestuff.prevjob || "",
  prevquote: quotestuff.prevquote || "",   // note: your sample uses prevQuote

  quote: quotestuff.quote || "",

  pname: quotestuff.pname || "",
  priority: quotestuff.priority || "Standard",

  pagecount: quotestuff.pagecount || "",
  coverstyle: quotestuff.coverstyle || "",
  versions: quotestuff.versions || "",
  versionnotes: quotestuff.versionnotes || "",

  pflatw: quotestuff.pflatw || "",
  pflatl: quotestuff.pflatl || "",
  pfoldw: quotestuff.pfoldw || "",
  pfoldl: quotestuff.pfoldl || "",

  quantity: quotestuff.quantity || "",

  bindstyle: quotestuff.bindstyle || "",
  presscheck: quotestuff.presscheck || "No",

  projectstyle: quotestuff.projectstyle || "",

  old: quotestuff.contact || "",

  // ────────────────────────────────────────────────
  // NEW: Build forms array from comp1–comp10
  // ────────────────────────────────────────────────
  forms: (() => {
    const formsArray = [];

    for (let i = 1; i <= 10; i++) {
      const key = `comp${i}`;
      const value = quotestuff[key];

      // Skip if missing, null, undefined, or empty string
      if (!value || typeof value !== 'string' || value.trim() === '') {
        continue;
      }

      const parts = value.split(':').map(part => part.trim());


        const paperObj = papers?.find(
        p => p.stockid === parts[2] || null);



console.log(paperObj)
      const form = {
        id:Date.now(),                           // or use Date.now() + i if needed
        componentKey: key,               // "comp1", "comp2", etc.
        raw: value,                      // keep original string for debugging

        componentName: parts[0] || "",
        paper:paperObj ,
        basisWeight: parts[2] || "",
        mWeight: parts[3] || "",         // guessing names — adjust!
        flatWidth: parts[4] || "",
        flatLength: parts[5] || "",
        foldWidth: parts[6] || "",
        foldLength: parts[7] || "",
        finks: parts[8].toUpperCase() || "",
        binks: parts[9].toUpperCase() || "",
        versions:1,
        pagecount:quotestuff?.pagecount,
        forms:1,
        fpercent:.07,
        bpercent:.07,
        fpasses:1,
        bpasses:1,
        fplates:(parts[8]).split(',').filter(Boolean).length || "",   
        bplates:(parts[9]).split(',').filter(Boolean).length || "", 
        press:null,
        // Add more fields here as needed:
        // aqueous: parts[10] || "",
        // varnish: parts[11] || "",
        // coatingType: parts[12] || "",
        // ...
        pressNotes: parts[20] || "",     // "Best Press" was around here
        // quantityPerComp: parts[25] || "",  // last "2" in your example
      };

      formsArray.push(form);
    }

    return formsArray;
  })(),
};
return Data


};





















export const methodcount = (item) => {

let a = 0
    switch(item){
case 'One-Sided':
    a =1;
    break;
case 'Sheetwise':
    a =2;
    break;    
    default:
        a = 0
    }

    return a
};

export const mrsetter = (item) => {
    let press = item.press?.id || null
    let method = item?.method || null
    let frontinks = item.fplates?.split(',').filter(Boolean).length || null
    let backinks = item.bplates?.split(',').filter(Boolean).length || null
console.log(press)
console.log(method)
console.log(frontinks)
console.log(backinks)
}


export const calculateMakeReady = (item) => {
  if (!item) return 0;
console.log(item)
  const fink = item.finks || '';
  const bink = item.binks || '';
  const method = item.method || '';
  const pressId = item.press?.id || null;
 // const numforms = Number(item.forms) || 1;   // default to 1 if not set

  // Count plates
  const fplates = fink.trim() === '' ? 0 : fink.split(',').filter(Boolean).length;
  let bplates = bink.trim() === '' ? 0 : bink.split(',').filter(Boolean).length;

  // Handle One-Sided method
  if (method === 'One-Sided') {
    bplates = 0;
  }

  const totalPlates = fplates + bplates;

  let a = 50;   // default value

  switch (String(pressId)) {
    case '3':
    case '4':
      switch (method) {
        case 'Sheetwise':
          a = totalPlates * 100;
          break;
        case 'Work & Turn':
        case 'Work & Tumble':
        case 'Perfect':
          a = fplates * 100 + 100;
          break;
        case 'One-Sided':
          a = fplates * 100;
          break;
        default:
          a = 0;
      }
      break;

    case '1':
    case '2':
      switch (method) {
        case 'Sheetwise':
          a = 600;
          break;
        case 'Work & Turn':
        case 'Work & Tumble':
        case 'Perfect':
          a = 400;
          break;
        case 'One-Sided':
          a = fplates * 100;
          break;
        default:
          a = 0;
      }
      break;

    case '5':
    case '6':
      switch (method) {
        case 'One-Sided':
          a = fplates * 500;
          break;
        default:
          a = totalPlates * 500;
      }
      break;

    default:
      a = 5;
  }

  // Multiply by number of forms
  //a = a * numforms;

  return a;
};